export default __webpack_public_path__ + "static/media/about1.398b1d24.jpg";